import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from '@material-ui/core';

import { Form } from 'form/form/Form';
import { CloseIcon } from 'ui/icons/closeIcon/CloseIcon';
import { CheckboxGroupField, GenericField } from 'form/fields';
import { Button } from 'ui';
import { useLocale } from 'hooks/useLocale/useLocale';

import { useStyles } from './TransferTokensModal.styles';
import { TransferTokensModalProps } from './TransferTokensModal.types';

export const TransferTokensModal = ({ isOpened, handleClose, onSubmit, tokens }: TransferTokensModalProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  const mintTokens = async (values: { tokens: string[]; address: string }) => {
    onSubmit(values.tokens, values.address);
    handleClose();
  };

  return (
    <Form defaultValues={{ tokens: [] }}>
      {({ handleSubmit }) => (
        <Dialog
          onClose={handleClose}
          open={isOpened}
          PaperProps={{ className: classes.container }}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle className={classes.titleContainer} disableTypography>
            {formatMessage({ id: 'transfer_modal.title' })}
            <IconButton onClick={handleClose} size="small">
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers className={classes.content}>
            <Grid container>
              <Grid item xs={12}>
                <GenericField label={formatMessage({ id: 'transfer_modal.address' })} name="address" required />
              </Grid>
              <Grid item xs={12}>
                <CheckboxGroupField
                  name={'tokens'}
                  items={tokens.map(token => ({
                    label: token,
                    value: token,
                  }))}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button onClick={handleClose} color="primary" variant="outlined">
              {formatMessage({ id: 'common.cancel' })}
            </Button>
            <Button onClick={handleSubmit(mintTokens)} color="primary" variant="contained">
              {formatMessage({ id: 'transfer_modal.transfer' })}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Form>
  );
};
